module.exports = __webpack_public_path__ + "img/annual_certificate_2.f9ea7f9e.svg";